import {UtilisateurBuilder} from 'sigale-angular';
import {UtilisateurSigalett} from './utilisateur-sigalett.model';

export class UtilisateurSigalettBuilder extends UtilisateurBuilder<UtilisateurSigalett> {
	override instancierUtilisateur(): UtilisateurSigalett {
		return new UtilisateurSigalett();
	}

	build(): UtilisateurSigalett {
		return super.build();
	}
}
